export default __webpack_public_path__ + "static/media/fxdx.3a9133af.svg";